<template>
    <v-date-picker v-model="model" :multiple="!single" no-title :first-day-of-week="weekStartDay" :locale="datePickerLocale"
        :show-current="false" :weekday-format="weekDays" class="container-date-picker" />
</template>

<script>
export default {
    props: {
        value: {
            type: [Array, String],
            default: null
        },
        single: {
            type: Boolean,
            default: false,
        },
        forceValue: {
            type: Boolean,
            default: false,
        }
    },
    name: "MiniCalendar",
    data(vm) {
        return {
            model: null,
            days: [
                vm.$t('days.short_sunday'),
                vm.$t('days.short_monday'),
                vm.$t('days.short_tuesday'),
                vm.$t('days.short_wednesday'),
                vm.$t('days.short_thursday'),
                vm.$t('days.short_friday'),
                vm.$t('days.short_saturday'),
            ],
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.value || vm.forceValue) vm.model = vm.value
        },
        weekDays(day) {
            const vm = this
            return vm.days[vm.$moment(day).day()]
        },
    },
    watch: {
        model(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>
.container-date-picker {
    padding: 12px 0;
    background-color: transparent !important;
}

::v-deep .v-picker__body {
    background: transparent;
}

::v-deep .v-date-picker-header .v-btn {
    color: var(--v-txtPrimary-base);
}

::v-deep .v-date-picker-header__value button {
    color: var(--v-txtPrimary-base) !important;
    font-weight: 700;
}

/*Cuerpo del datepicker completo*/
::v-deep .v-date-picker-table {
    height: 100%;
    border-bottom: none;
}

/*Text de los dias*/
::v-deep thead>tr>th {
    font-weight: 600 !important;
    font-size: 12px !important;
    line-height: 13px !important;
    color: var(--v-accent-base) !important;
}

::v-deep .v-date-picker-table .v-btn {
    color: var(--v-txtSecondary-base);
    border-radius: 8px;
    width: 100%;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
    color: #fff !important;
    background-color: var(--v-accent-base) !important;
}

::v-deep .v-date-picker-table .v-btn--active::before {
    opacity: 0;
}

::v-deep .v-date-picker-table .v-btn--active .v-btn__content {
    font-weight: 600;
}

.container-date-picker.theme--dark ::v-deep thead > tr > th {
    color: var(--v-primary-base) !important;
}

.container-date-picker.theme--dark ::v-deep .v-date-picker-table .v-btn.v-btn--active {
    color: #080A0E !important;
    background-color: var(--v-primary-base) !important;
}
</style>